import { inject } from '@angular/core';
import { AppUser, AuthService } from '@app/components/login.component';
import { NTAPMenuItem, NTAPMenuService } from '@ntap/common';
import { MenuItem } from 'primeng/api';
import { map, Observable, switchMap } from 'rxjs';

// FIXME ovo je napravljeno za demo za 02.07.25. maknuti kasnije
export class ArhivMenuService extends NTAPMenuService {
  private authService = inject(AuthService);

  private readonly labelsToExclude = [
    'Javni katalog',
    'Istaknuti sadržaj',
    'Evidencije',
    'Normativna baza osoba',
    'Normativna baza mjesta',
    'Zahtjevi za deduplikaciju agenata',
    'Akvizicije i depoziti'
  ];

  override getMenuItems(
    defaultMenuItems?: NTAPMenuItem[]
  ): Observable<NTAPMenuItem[]> {
    return super.getMenuItems(defaultMenuItems).pipe(
      switchMap((menus) =>
        this.authService.user$.pipe(map((user) => [menus, user]))
      ),
      map(([menus, user]) => {
        const ntapMenus = menus as NTAPMenuItem[];

        return this.filterForest(
          ntapMenus,
          (menuItem) =>
            (user as AppUser).name == 'admin@ent.hr' &&
            !!menuItem.label &&
            this.labelsToExclude.indexOf(menuItem.label) >= 0
        );
      })
    );
  }

  private filterForest(
    menus: NTAPMenuItem[],
    predicate: (n: MenuItem) => boolean
  ): NTAPMenuItem[] {
    return menus
      .map((node) => this.filterTree(node, predicate))
      .filter((node): node is NTAPMenuItem => node !== undefined);
  }

  private filterTree(
    node: NTAPMenuItem,
    predicate: (n: MenuItem) => boolean
  ): NTAPMenuItem | undefined {
    if (!node || predicate(node)) {
      return undefined;
    }

    if (node.items) {
      node.items = node.items
        .map((child) => this.filterTree(child, predicate))
        .filter((child): child is NTAPMenuItem => child !== undefined);
    }
    return node;
  }
}
